export const feedbackOnFeedbackInitialState = {
  recordInEditMode: undefined,
  editedRecords: [],
  flaggedSummaryRecords: [],
  shouldRefetch: false,
};
